import { logDebugWithBackoff } from '@/utils/debug-logging-adapter';
import type { DebugMeta, LogDebugRequest } from '@/utils/log-debug-types';

const SOURCE_NAME = 'cb-checkout-v3';
const SOURCE_VERSION =
  (typeof process !== 'undefined' && process.env && process.env.CB_BUILD_TAG) || '0.0.0';

function getRoute(): string | undefined {
  if (typeof window === 'undefined' || !window.location) {
    return undefined;
  }
  return window.location.pathname || undefined;
}

/**
 * Build LogDebugRequest and send to hp-service /log/debug.
 * Telemetry only (no cause, no Sentry). Mirrors cb-hp-ui Logger.debug.
 */
export function logDebug(code: string, payload: DebugMeta = {}): void {
  const payloadObj = payload && typeof payload === 'object' && payload !== null ? payload : {};
  const hasPayloadKeys = Object.keys(payloadObj).length > 0;
  const route = getRoute();

  const meta: DebugMeta = {
    ...(hasPayloadKeys ? payloadObj : {}),
  };

  const trackingPayload: LogDebugRequest = {
    debug_code: code,
    ...(Object.keys(meta).length > 0 ? { meta } : {}),
    ...(route ? { route } : {}),
    source: { name: SOURCE_NAME, version: SOURCE_VERSION },
  };

  logDebugWithBackoff(trackingPayload);
}
